export interface TestResultDto {
    attempt: number;
    contactId: string;
    lastUpdatedDate: Date;
    level: LevelSummaryDto;
    status: TestStatus;
    testScorePercentage: number;
    testType: LearnosityTestType;
}

export enum TestStatus {
    PASSED = 'PASSED',
    FAILED = 'FAILED'
}

export enum LearnosityTestType {
    END_OF_LEVEL = 'END_OF_LEVEL',
    MID_LEVEL = 'MID_LEVEL',
  }

export interface LevelSummaryDto {
    description: string;
    id: number;
    name: string;
    units: UnitSummaryDto[];
}  

export interface UnitSummaryDto {
    description: string;
    id: number;
    name: string;
}


// WEBPACK FOOTER //
// ./ts/app/shared/types/TestResultDto.ts